// Generated by purs version 0.15.0
import * as Algorithm_NaturalSort from "../Algorithm.NaturalSort/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Memo from "../Restaumatic.Menu.V2.Memo/index.js";
import * as Restaumatic_Menu_V2_Parameter from "../Restaumatic.Menu.V2.Parameter/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_CustomParameter from "../Restaumatic.Menu.V2.Types.CustomParameter/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Types_MenuSection from "../Restaumatic.Menu.V2.Types.MenuSection/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_Product from "../Restaumatic.Menu.V2.Types.Product/index.js";
import * as Restaumatic_Menu_V2_Types_ProductCategory from "../Restaumatic.Menu.V2.Types.ProductCategory/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var ProductNode = function (x) {
    return x;
};
var CategoryNode = function (x) {
    return x;
};
var ProductCategoryTree = function (x) {
    return x;
};
var withId = function (lookup) {
    return function (id) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create(id))(lookup(id));
    };
};
var productsInCategoryCount = function (v) {
    return function (categoryId) {
        return Data_Maybe.maybe(0)(function (v1) {
            return Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(v1.products);
        })(Data_Foldable.find(Data_Foldable.foldableArray)(function (v1) {
            return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v1.id)(categoryId);
        })(v.categories));
    };
};
var modifierItems = function (modifier) {
    return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Map_Ordered.monoidOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Data_Functor.map(Data_Functor.functorArray)((function () {
        var $79 = Data_Newtype.unwrap();
        return function ($80) {
            return (function (v) {
                return v.items;
            })($79($80));
        };
    })())(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "sections";
        }
    })()))(Type_Proxy["Proxy"].value)(modifier)));
};
var modifierDefaultChoices = function (modifier) {
    return Data_OrderedMultiSet.fromOccurArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return new Data_Tuple.Tuple(v.value0, Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "defaultSelection";
            }
        })()))(Type_Proxy["Proxy"].value)(v.value1));
    })(Data_Map_Ordered.toArray(modifierItems(modifier))));
};
var modifierDefaultChoiceNames = function (modifier) {
    return Data_Array.filter(function (v) {
        return v.value1 > 0;
    })(Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return new Data_Tuple.Tuple(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "name";
            }
        })()))(Type_Proxy["Proxy"].value)(v.value1), Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "defaultSelection";
            }
        })()))(Type_Proxy["Proxy"].value)(v.value1));
    })(Data_Map_Ordered.toArray(modifierItems(modifier))));
};
var lookupSection = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "sections";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupSectionItem = function (catalogue) {
    return function (menuSectionId) {
        return function (menuSectionItemId) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(lookupSection(catalogue)(menuSectionId))(function (section) {
                var v = Data_Record.getField(Restaumatic_Menu_V2_Types_MenuSection.hasFieldMenuSection(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "content";
                    }
                })()))(Type_Proxy["Proxy"].value)(section);
                if (v instanceof Restaumatic_Menu_V2_Types_MenuSection.Products) {
                    return Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(menuSectionItemId)(v.value0.items);
                };
                return Data_Maybe.Nothing.value;
            });
        };
    };
};
var lookupProductCategory = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "categories";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupProduct = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "products";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var productCategoryTree = function (locale) {
    return function (catalogue) {
        var allProducts = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "products";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
        var treeOfIds = Data_Map_Internal.fromFoldableWith(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Foldable.foldableArray)(Data_Set.union(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return new Data_Tuple.Tuple(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "category";
                }
            })()))(Type_Proxy["Proxy"].value)(v.value1), Data_Set.singleton(v.value0));
        })(allProducts));
        return {
            categories: Data_Array.sortBy(Data_Ord.comparing(Data_Ord.ordArray(Algorithm_NaturalSort.ordSortChunk))(function (v) {
                return Algorithm_NaturalSort.naturalKey(Data_String_Common.toUpper(v.name));
            }))(Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(treeOfIds))(function (v) {
                var v1 = lookupProductCategory(catalogue)(v.value0);
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Data_Maybe.Nothing.value;
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return new Data_Maybe.Just({
                        id: v.value0,
                        category: v1.value0,
                        name: Data_Record.getField(Restaumatic_Menu_V2_Types_ProductCategory.hasFieldProductCategory(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "name";
                            }
                        })()))(Type_Proxy["Proxy"].value)(v1.value0),
                        products: Data_Array.sortBy(Data_Ord.comparing(Data_Ord.ordArray(Algorithm_NaturalSort.ordSortChunk))(function (v2) {
                            return Algorithm_NaturalSort.naturalKey(Data_String_Common.toUpper(v2.translatedName));
                        }))(Data_Array.catMaybes(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Array.fromFoldable(Data_Set.foldableSet)(v.value1))(function (productId) {
                            var v2 = lookupProduct(catalogue)(productId);
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return Data_Maybe.Nothing.value;
                            };
                            if (v2 instanceof Data_Maybe.Just) {
                                return new Data_Maybe.Just({
                                    id: productId,
                                    product: v2.value0,
                                    translatedName: Restaumatic_I18n_Types.getLocalization(locale)(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "name";
                                        }
                                    })()))(Type_Proxy["Proxy"].value)(v2.value0))
                                });
                            };
                            throw new Error("Failed pattern match at Restaumatic.Menu.V2.MenuCatalogue (line 218, column 15 - line 224, column 20): " + [ v2.constructor.name ]);
                        })))
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Menu.V2.MenuCatalogue (line 211, column 7 - line 225, column 12): " + [ v1.constructor.name ]);
            })))
        };
    };
};
var lookupModifier = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "modifiers";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupProductBaseItems = function (catalogue) {
    return function (product) {
        var mapa = Data_Map_Internal.filter(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldModifierSettings(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "displayDefaultItems";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        })(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "modifierSettings";
            }
        })()))(Type_Proxy["Proxy"].value)(product)));
        var valuesCount = Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_List_Types.foldableList)(Data_Functor.map(Data_List_Types.functorList)(Data_Tuple_T2.toTuple)(Data_List.concat(Data_Functor.map(Data_List_Types.functorList)(Data_List.fromFoldable(Data_Foldable.foldableArray))(Data_List.mapMaybe(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldModifierSettings(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "defaultItems";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        })(Data_Map_Internal.values(mapa))))));
        var keys = Data_List.mapMaybe(lookupModifier(catalogue))(Data_List.fromFoldable(Data_Set.foldableSet)(Data_Map.keys(mapa)));
        var isDefault = function (id) {
            return Data_Maybe.fromMaybe(0)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(valuesCount)) > 0;
        };
        return Data_Functor.map(Data_List_Types.functorList)(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "name";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        })(Data_Map_Internal.values(Data_Map_Internal.filterKeys(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(isDefault)(Data_Map_Ordered.toMap(Data_Foldable.fold(Data_List_Types.foldableList)(Data_Map_Ordered.monoidOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Data_Functor.map(Data_List_Types.functorList)(modifierItems)(keys))))));
    };
};
var productDefaultSelection$prime = function (catalogue) {
    return function (product) {
        var modifierIds = Restaumatic_Menu_V2_Parameter.allModifiers(Restaumatic_Menu_V2_Memo.memo(catalogue))(product);
        var getProductSelection = function (modifierId) {
            return Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(modifierId)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "modifierSettings";
                }
            })()))(Type_Proxy["Proxy"].value)(product))))(function (v) {
                return Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldModifierSettings(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "defaultItems";
                    }
                })()))(Type_Proxy["Proxy"].value)(v);
            }))(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.toTuple));
        };
        var getDefaultSelection = function (modifierId) {
            return Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray))(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(lookupModifier(catalogue)(modifierId))(function (modifier) {
                return Control_Bind.bind(Control_Bind.bindArray)(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "sections";
                    }
                })()))(Type_Proxy["Proxy"].value)(modifier))(function (section) {
                    return Control_Bind.bind(Control_Bind.bindArray)(Data_Map_Ordered.toArray(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItemSecti(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })()))(Type_Proxy["Proxy"].value)(section)))(function (v) {
                        return Control_Applicative.pure(Control_Applicative.applicativeArray)(new Data_Tuple.Tuple(v.value0, Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "defaultSelection";
                            }
                        })()))(Type_Proxy["Proxy"].value)(v.value1)));
                    });
                });
            }));
        };
        return Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Foldable.foldableArray)(Data_Functor.mapFlipped(Data_Functor.functorArray)(modifierIds)(function (modifierId) {
            return new Data_Tuple.Tuple(modifierId, Data_Newtype.wrap()(Data_MultiSet.fromOccurArray(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Maybe.fromMaybe(getDefaultSelection(modifierId))(getProductSelection(modifierId)))));
        }));
    };
};
var lookupMenu = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()((Data_Newtype.unwrap()(catalogue)).menus));
    };
};
var lookupCustomParameter = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "customParameters";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupCustomParameterDefaults = function (catalogue) {
    return function (customParameters) {
        var lookupDefault = function (parameterId) {
            var v = lookupCustomParameter(catalogue)(parameterId);
            if (v instanceof Data_Maybe.Just) {
                return Data_Maybe.maybe(Data_Map_Internal.empty)(Data_Map_Internal.singleton(parameterId))(Data_Record.getField(Restaumatic_Menu_V2_Types_CustomParameter.hasFieldCustomParameter(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "defaultChoice";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Map_Internal.empty;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.MenuCatalogue (line 71, column 5 - line 73, column 27): " + [ v.constructor.name ]);
        };
        return Data_Map_Internal.unions(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(lookupDefault)(customParameters));
    };
};
var lookupCrossSellingList = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "crossSellingListsV2";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupCombo = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "combos";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var lookupAvailabilitySchedule = function (catalogue) {
    return function (id) {
        return Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(id)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "availabilitySchedules";
            }
        })()))(Type_Proxy["Proxy"].value)(catalogue)));
    };
};
var isProductAvailableInFulfillmentMethod = function (fulfillmentMethod) {
    return function (product) {
        var fulfillmentParameter = Data_Map_Internal.singleton(new Restaumatic_Menu_V2_Types_ParameterId.InternalParameter(Restaumatic_Menu_V2_Types_InternalParameterId.FulfillmentMethod.value))(new Restaumatic_Menu_V2_Types_ParameterChoiceId.InternalParameterChoice(new Restaumatic_Menu_V2_Types_InternalParameterChoiceId.FulfillmentMethodChoice(fulfillmentMethod)));
        return Restaumatic_Menu_V2_Parametric.isPossible(Restaumatic_Menu_V2_Parametric.isParametricPossibleBoole)(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "variants";
            }
        })()))(Type_Proxy["Proxy"].value)(product))(fulfillmentParameter);
    };
};
var displayedProductModifierDefaultChoiceNames = function (modifier) {
    return function (modifierId) {
        return function (product) {
            var v = Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v1) {
                return v1.modifierSettings;
            }))(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(modifierId));
            if (v instanceof Data_Maybe.Just && Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(v.value0)(function (v1) {
                return v1.displayDefaultItems;
            }) === true) {
                var v1 = Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(v.value0)(function (v2) {
                    return v2.defaultItems;
                });
                if (v1 instanceof Data_Maybe.Just) {
                    var selectedItems = Data_Functor.map(Data_Functor.functorArray)(Data_Tuple_T2.toTuple)(v1.value0);
                    var items = modifierItems(modifier);
                    var lookupItem = function (v2) {
                        return Data_Functor.map(Data_Maybe.functorMaybe)(function (item) {
                            return new Data_Tuple.Tuple(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(item)(function (v3) {
                                return v3.name;
                            }), v2.value1);
                        })(Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v2.value0)(items));
                    };
                    return Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(lookupItem)(selectedItems));
                };
                return [  ];
            };
            return [  ];
        };
    };
};
var productDefaultSelection = function (catalogue) {
    return function (productId) {
        return Data_Maybe.fromMaybe([  ])(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(lookupProduct(catalogue)(productId))(function (product) {
            var modifierIds = Restaumatic_Menu_V2_Parameter.allModifiers(Restaumatic_Menu_V2_Memo.memo(catalogue))(product);
            var modifiers = Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(withId(lookupModifier(catalogue)))(modifierIds));
            var modifierDefaultItems = function (v) {
                return displayedProductModifierDefaultChoiceNames(v.value1)(v.value0)(product);
            };
            return Data_Functor.map(Data_Functor.functorArray)(modifierDefaultItems)(modifiers);
        }));
    };
};
var productDefaultDisplayedSelectionString = function (locale) {
    return function (catalogue) {
        return function (productId) {
            return Data_String_Common.joinWith(", ")(Data_Functor.mapFlipped(Data_Functor.functorArray)(Control_Bind.join(Control_Bind.bindArray)(productDefaultSelection(catalogue)(productId)))(function (v) {
                return Data_Monoid_Extra.mwhen(Data_Monoid.monoidString)(v.value1 > 1)(Data_Show.show(Data_Show.showInt)(v.value1) + " x ") + Restaumatic_I18n_Types.getLocalization(locale)(v.value0);
            }));
        };
    };
};
var customParameterNames = function (catalogue) {
    return Data_Functor.mapFlipped(Data_Map_Internal.functorMap)(Data_Newtype.unwrap()((Data_Newtype.unwrap()(catalogue)).customParameters))((function () {
        var $81 = Data_Newtype.unwrap();
        return function ($82) {
            return (function (v) {
                return v.name;
            })($81($82));
        };
    })());
};
export {
    lookupSectionItem,
    lookupProduct,
    lookupCombo,
    lookupProductCategory,
    lookupSection,
    lookupCustomParameter,
    customParameterNames,
    lookupCustomParameterDefaults,
    lookupProductBaseItems,
    lookupModifier,
    lookupMenu,
    modifierItems,
    modifierDefaultChoices,
    modifierDefaultChoiceNames,
    displayedProductModifierDefaultChoiceNames,
    lookupAvailabilitySchedule,
    lookupCrossSellingList,
    productDefaultSelection,
    productDefaultDisplayedSelectionString,
    withId,
    productDefaultSelection$prime,
    isProductAvailableInFulfillmentMethod,
    ProductCategoryTree,
    CategoryNode,
    ProductNode,
    productCategoryTree,
    productsInCategoryCount
};
//# sourceMappingURL=index.js.map
